<template>
    <div class="service-providers-select-provider-step">
        <div
                v-if="!hideHeader"
                class="step-header"
        >
            <lazy-public-storage-image
                    class="mb-3"
                    :file="resource.icon"
                    :alt="resource.projectLabel"
                    :width="100"
                    :height="100"
                    keep-aspect-ratio
            />

            <div class="title">
                {{ resource.projectLabel }}
            </div>
            <div class="subtitle">
                {{ resource.description }}
            </div>
        </div>

        <slot name="service-provider-step-before-cards" />
        <b-row class="service-provider-cards-wrapper">
            <b-col
                    v-for="serviceProvider in serviceProviders"
                    :key="serviceProvider.uuid"
                    :cols="6"
                    :md="3"
                    align-self="stretch"
                    class="card-wrapper"
            >
                <service-provider-card
                        :service-provider="serviceProvider"
                        class="h-100"
                        selectable
                        :selected="getIsSelectedCard(serviceProvider)"
                        @select="handleSelect"
                        :select-type="isMultiple ? SELECT_TYPES.CHECKBOX : SELECT_TYPES.RADIO"
                        :variant="isMultiple ? 'simple-phone-website' : 'simple'"
                />
            </b-col>
        </b-row>

        <div class="get-connected-button-wrapper">
            <b-button
                    class="get-connected-button"
                    variant="primary"
                    size="lg"
                    :disabled="!canConnect"
                    @click="handleGetConnected"
            >
                Get Connected
            </b-button>
        </div>

        <div
                v-if="!hideFooter"
                class="step-footer"
        >
            <div class="disclaimer">
                There are many options available. You are free to shop around to determine that you are receiving the
                best
                services and rates available. The information above is provided for your reference, without warranty of
                any
                kind.
            </div>
        </div>
    </div>
</template>

<script>
    import './SelectProviderStep.scss';
    import ServiceProviderAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/ServiceProviderAppResource";
    import ServiceProviderCard,
    {SELECT_TYPES}
        from "../../ServiceProviderCard/ServiceProviderCard.vue";
    import isEmpty from 'lodash/isEmpty';
    import AppResourceCollection from "@milestoneslabs/milestones-js-engine/src/Data/AppResourceCollection";
    import ResourceAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/ResourceAppResource";

    export default {
        name: "SelectProviderStep",
        components: {
            ServiceProviderCard,
        },

        props: {
            serviceProviders: {
                type: AppResourceCollection,
                required: true,
            },

            resource: {
                type: ResourceAppResource,
                required: true,
            },

            hideHeader: {
                type: Boolean,
                default: false,
            },

            hideFooter: {
                type: Boolean,
                default: false,
            },
            isMultiple: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                SELECT_TYPES,
                selectedServiceProvider: new ServiceProviderAppResource({}),
                selectedServiceProviders: [],
                isLoading: false,
            };
        },

        computed: {
            canConnect() {
                if (!this.isMultiple) {
                    return !isEmpty(this.selectedServiceProvider) &&
                        this.selectedServiceProvider instanceof ServiceProviderAppResource &&
                        this.selectedServiceProvider.exists;
                }

                return Boolean(this.selectedServiceProviders.length);

            }
        },

        methods: {
            handleSelect(serviceProvider) {
                if (!this.isMultiple) {
                    this.selectedServiceProvider = serviceProvider;
                }
                const found = this.selectedServiceProviders.find(item => item.uuid === serviceProvider.uuid);
                if (!Boolean(found)) {
                    this.selectedServiceProviders.push(serviceProvider);
                } else {
                    this.selectedServiceProviders = this.selectedServiceProviders.filter(item => item.uuid !== serviceProvider.uuid);
                }
            },

            handleGetConnected() {
                const payload = this.isMultiple ? this.selectedServiceProviders : this.selectedServiceProvider;
                this.$emit('connect', payload);
            },

            getIsSelectedCard(serviceProvider) {
                if (!this.isMultiple) {
                    return serviceProvider.uuid === this.selectedServiceProvider.uuid;
                }
                return Boolean(this.selectedServiceProviders.find(item => item.uuid === serviceProvider.uuid));
            }
        },
    };
</script>
